import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { GroupedTreeNode, ITreeNode } from "src/app/core/datasets/tree.interface";
import { AdminService } from "../../admin/admin.service";

@Component({
  selector: 'mood-category-tree-node',
  templateUrl: './category-tree-node.component.html',
  styleUrls: ['./category-tree-node.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CategoryTreeNodeComponent {
  @Input() node!: ITreeNode;

  constructor(private _adminService: AdminService) {}

  public get childNodes() {
    return (this.node as GroupedTreeNode).children || [];
  }

  selectCategory() {
    this._adminService.changeSelectedCategory.emit((this.node as GroupedTreeNode).category_id);
  }
}
